<template>
    <KTLoader v-if="loaderEnabled" :logo="loaderLogo"></KTLoader>

    <!-- begin:: Body -->
    <div class="page d-flex flex-row flex-column-fluid">
        <!-- begin:: Aside Left -->
        <KTAside v-if="asideEnabled" :lightLogo="themeLightLogo" :darkLogo="themeDarkLogo"></KTAside>
        <!-- end:: Aside Left -->

        <div id="kt_wrapper" class="d-flex flex-column flex-row-fluid wrapper">
            <KTHeader :title="pageTitle"></KTHeader>

            <!-- begin:: Content -->
            <div id="kt_content" class="content d-flex flex-column flex-column-fluid">
                <!-- begin:: Content Head -->
                <KTToolbar v-if="subheaderDisplay" :breadcrumbs="breadcrumbs" :title="pageTitle"/>
                <!-- end:: Content Head -->

                <!-- begin:: Content Body -->
                <div class="post d-flex flex-column-fluid">
                    <div id="kt_content_container" :class="{ 'container-fluid': contentWidthFluid,'container-xxl': !contentWidthFluid}">
                        <router-view/>
                    </div>
                </div>
                <!-- end:: Content Body -->
            </div>
            <!-- end:: Content -->
            <KTFooter></KTFooter>
        </div>
    </div>
    <!-- end:: Body -->
    <KTScrollTop></KTScrollTop>
    <KTDrawerMessenger></KTDrawerMessenger>
    <NoteApp ref="noteApp"/>
    <AgendaPanel ref="agendaPanel"/>
    <WeatherPanel ref="weatherPanel"/>
    <FileManagerPanel ref="fileManagerPanel"/>
    <MusicPanel ref="musicPanel"/>
    <BillingPanel v-if="false" ref="billingPanel"/>
    <DataTablePanel ref="dataTablePanel"/>
    <SpotlightPanel ref="spotlightPanel"/>
    <PaymentPanel ref="paymentPanel"/>
    <ConfirmDialog ref="confirmDialog"/>
    <DateTimePicker ref="dateTimePicker" global/>
    <AppDock/>
</template>

<script>
import KTAside from "@/layouts/aside/Aside.vue";
import KTHeader from "@/layouts/header/Header.vue";
import KTFooter from "@/layouts/footer/Footer.vue";
import HtmlClass from "@/core/services/LayoutService";
import KTToolbar from "@/layouts/toolbar/Toolbar.vue";
import KTScrollTop from "@/layouts/extras/ScrollTop.vue";
import ProtectArea from "@/components/protect-area"
import KTLoader from "@/components/Loader.vue";
import KTDrawerMessenger from "@/layouts/extras/DrawerMessenger.vue";
import NoteApp from "@/components/note/NoteApp.vue";
import AgendaPanel from "@/components/agenda/AgendaPanel.vue";
import WeatherPanel from "@/components/weather/WeatherPanel.vue";
import FileManagerPanel from "@/components/filemanager/FileManagerPanel.vue";
import MusicPanel from "@/components/music/MusicPanel.vue";
import BillingPanel from "@/components/billing/BillingPanel.vue";
import DataTablePanel from "@/components/datatable/DataTablePanel.vue";
import SpotlightPanel from "@/components/spotlight/SpotlightPanel.vue";
import PaymentPanel from "@/components/payment/PaymentPanel.vue";
import ConfirmDialog from "@/components/common/confirm-dialog/ConfirmDialog.vue";
import DateTimePicker from "@/components/common/date-time-picker/DateTimePicker.vue";
import AppDock from "@/components/dock/AppDock.vue";
import panelManager from "@/core/helpers/panelManager";
import {Actions} from "@/store/enum/StoreEnums";
import {removeModalBackdrop} from "@/core/helpers/dom";
import {
    MenuComponent,
    DrawerComponent,
    ScrollComponent,
} from "@/assets/js/components/index";
import {
    toolbarDisplay,
    loaderEnabled,
    contentWidthFluid,
    loaderLogo,
    asideEnabled,
    subheaderDisplay,
    themeLightLogo,
    themeDarkLogo,
} from "@/core/helpers/config";

export default {
    name: 'default',
    data() {
        return {
            toolbarDisplay,
            loaderEnabled,
            contentWidthFluid,
            loaderLogo,
            asideEnabled,
            subheaderDisplay,
            themeLightLogo,
            themeDarkLogo,
        }
    },
    components: {
        KTAside,
        KTHeader,
        KTFooter,
        KTToolbar,
        KTScrollTop,
        KTDrawerMessenger,
        KTLoader,
        ProtectArea,
        NoteApp,
        AgendaPanel,
        WeatherPanel,
        FileManagerPanel,
        MusicPanel,
        BillingPanel,
        DataTablePanel,
        SpotlightPanel,
        PaymentPanel,
        ConfirmDialog,
        DateTimePicker,
        AppDock,
    },
    created() {
        // show page loading
        this.$store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");

        // initialize html element classes
        HtmlClass.init();
    },
    computed: {
        pageTitle() {
            return this.$store.getters.pageTitle;
        },
        breadcrumbs() {
            return this.$store.getters.pageBreadcrumbPath;
        },
        isAccess() {
            return this.$store.getters.isAccess;
        },
        showPage(){
            return this.$root.defaultCurrency.id && this.$root.defaultLanguage.id;
        }
    },
    mounted() {
        DrawerComponent.bootstrap();
        ScrollComponent.bootstrap();
        DrawerComponent.updateAll();
        ScrollComponent.updateAll();

        setTimeout(() => {
            // Remove page loader after some time
            this.$store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
        }, 500);

        // EventBus listener
        this._openPanelHandler = ({ panelId, ...context }) => {
            panelManager.openPanel(panelId, Object.keys(context).length ? context : undefined);
        };
        this.eventBus.$on('panel:open', this._openPanelHandler);

        this.$nextTick(() => panelManager.openAutoLoadPanels())
    },
    beforeUnmount() {
        if (this._openPanelHandler) {
            this.eventBus.$off('panel:open', this._openPanelHandler);
        }
    },
    watch: {
        '$route.path': function () {
            MenuComponent.hideDropdowns(undefined);

            DrawerComponent.hideAll();

            //check if current user is authenticated
            if (!this.$store.getters.isUserAuthenticated) {
                this.$router.push({name: "login"});
            }

            removeModalBackdrop();
        }
    },
}
</script>